import React, { useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import usePersonaManagement from "../hooks/usePersonaManagement";

const LineChats = (props) => {
  const jsonData = props.jsonData;
  const passtoken = JSON.parse(
    localStorage.getItem("access-token-storage")
  )?.["accessToken"];
  const { personaOptions, loading: personaLoading } =
    usePersonaManagement(passtoken);

  const availablePersonaOptions = useMemo(() => {
    if (!jsonData) return personaOptions;
    return personaOptions.filter((option) => jsonData[option.label]);
  }, [personaOptions, jsonData]);

  const chartOptions =
    availablePersonaOptions.length > 0
      ? availablePersonaOptions
      : personaOptions;

  const [selectedChart, setSelectedChart] = useState("");

  useEffect(() => {
    if (!selectedChart && chartOptions.length > 0) {
      setSelectedChart(chartOptions[0].label);
    } else if (
      selectedChart &&
      chartOptions.length > 0 &&
      !chartOptions.some((option) => option.label === selectedChart)
    ) {
      setSelectedChart(chartOptions[0].label);
    }
  }, [chartOptions, selectedChart]);

  const handleChartTypeChange = (e) => {
    setSelectedChart(e.target.value);
  };

  const selectedData = jsonData?.[selectedChart];

  if (!selectedData || !selectedData.chats?.[0]) {
    return (
      <div>
        <select
          id="chart-type"
          value={selectedChart}
          onChange={handleChartTypeChange}
          disabled={personaLoading || chartOptions.length === 0}
        >
          {chartOptions.map((option) => (
            <option key={option.value} value={option.label}>
              {option.label}
            </option>
          ))}
        </select>
        <div style={{ padding: "1rem" }}>
          {personaLoading
            ? "Loading personas..."
            : "No chart data available for the selected persona."}
        </div>
      </div>
    );
  }

  const series = [
    {
      name: selectedData.name,
      data: selectedData.chats[0].YAxis,
    },
  ];

  const options = {
    chart: {
      type: "line",
      height: 450,
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: "smooth",
    },
    markers: {
      size: 6,
      strokeWidth: 2,
      shape: "circle",
      radius: 2,
    },
    xaxis: {
      categories: selectedData.chats[0].XAxis,
      tickPlacement: "on",
      position: "bottom",
      labels: {
        show: true,
        rotate: -75,
        rotateAlways: true,
        trim: true,
        hideOverlappingLabels: true,
        offsetX: 0,
        offsetY: 10,
        maxHeight: 70,
        minHeight: 50,
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        gradientToColors: ["#FDD835"],
        shadeIntensity: 1,
        type: "horizontal",
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100, 100, 100],
      },
    },
  };

  return (
    <div>
      <select
        id="chart-type"
        value={selectedChart}
        onChange={handleChartTypeChange}
        disabled={personaLoading || chartOptions.length === 0}
      >
        {chartOptions.map((option) => (
          <option key={option.value} value={option.label}>
            {option.label}
          </option>
        ))}
      </select>

      <div style={{ borderRadius: "10px" }}>
        <ReactApexChart
          options={options}
          series={series}
          type="line"
          height={300}
        />
      </div>
    </div>
  );
};

export default LineChats;
